<template>
  <div class="content">
    <div class="md-layout mobile-container">
      <h3
        class="md-headline"
        style="padding: 0 15px"
      >
        Create New Shortcut
      </h3>
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
        <form
          class="shortcut-form"
          @submit.prevent="() => {}"
        >
          <shortcut-form
            :shortcut.sync="shortcut"
            :validation="$v.shortcut"
            :submitted="submitted"
          />

          <date-range-form
            :initial_date_interval="shortcut.date_interval"
            :enabled="shortcut.enabled"
            :validation="$v.shortcut.date_interval"
            @dateRangeUpdated="onDateRangeUpdate"
          />

          <c-t-a-form :cta.sync="shortcut.cta" />

          <images-form
            :images.sync="shortcut.images"
            :background_color.sync="shortcut.background_color"
          />

          <benefits-form :benefits.sync="shortcut.benefits" />

          <actions-form :actions.sync="shortcut.actions" />

          <md-field>
            <label>Successful Message</label>
            <md-input v-model="shortcut.successful_message" />
          </md-field>

          <label>Payload</label>
          <prism-editor
            v-model="shortcut.payload"
            :code="shortcut.payload"
            language="js"
          />
          <div
            v-if="submitted && !$v.shortcut.payload.required"
            class="error-feedback"
          >
            Field is
            required
          </div>
          <div
            v-if="submitted && !$v.shortcut.payload.isValidJSON"
            class="error-feedback"
          >
            JSON is not
            valid
          </div>

          <div class="new-sh-columns-wrapper">
            <md-card>
              <md-card-content>
                <h3>Tags:</h3>
                <md-chip
                  v-for="tag in tags"
                  :key="tag"
                  class="md-primary"
                  md-deletable
                  @click="deleteChip(tag)"
                >
                  {{ tag }}
                </md-chip>
                <md-autocomplete
                  v-model="selectTagValue"
                  :md-options="tagsIndex"
                  :md-fuzzy-search="false"
                >
                  <label>Tags</label>
                  <template
                    slot="md-autocomplete-item"
                    slot-scope="{ item, term }"
                  >
                    <md-highlight-text :md-term="term">
                      {{ item }}
                    </md-highlight-text>
                  </template>

                  <template
                    slot="md-autocomplete-empty"
                    slot-scope="{ term }"
                  >
                    No tags matching "{{ term }}" were found.
                    <md-button @click="createTag(term)">
                      Create a new
                    </md-button>
                    one!
                  </template>
                </md-autocomplete>
                <md-button
                  class="md-primary"
                  @click="addTag()"
                >
                  Add tag
                </md-button>
              </md-card-content>
            </md-card>

            <md-card>
              <md-card-content>
                <server-bundles-selector @serverListChanged="onServerListChanged" />
              </md-card-content>
            </md-card>
          </div>

          <div class="new-sh-columns-wrapper">
            <md-card>
              <md-card-content>
                <country-selector-with-continents
                  @countryListChanged="countrySelected"
                  @modeChanged="modeChanged"
                />
              </md-card-content>
            </md-card>

            <md-card>
              <md-card-content>
                <platforms-selector
                  @platformsListChanged="platformSelected"
                  @platformsModeChanged="platformModeChanged"
                />
              </md-card-content>
            </md-card>
          </div>

          <div class="new-sh-columns-wrapper">
            <md-card>
              <md-card-content>
                <apps-selector
                  @appsListChanged="onAppsListChanged"
                  @appsModeChanged="onAppsModeChanged"
                />
              </md-card-content>
            </md-card>

            <md-card>
              <md-card-content>
                <nodes-mode-selector
                  :nodes_list_expanded="shortcut.nodes_list_expanded"
                  :node_representation="shortcut.node_representation"
                  @listExpandedUpdate="onNodesListExtendedUpdate"
                  @representationUpdate="onNodesRepresentationUpdate"
                />
              </md-card-content>
            </md-card>
          </div>

          <div>
            <md-button
              class="md-success"
              @click.native="createShortcut"
            >
              Save
            </md-button>
          </div>
          <div class="error-feedback">
            {{ errorMsg }}
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
    import "prismjs";
    import "prismjs/themes/prism-tomorrow.css";
    import PrismEditor from "vue-prism-editor";
    import {required} from "vuelidate/lib/validators";
    import {
        AppsSelector,
        ActionsForm,
        BenefitsForm,
        CTAForm,
        ImagesForm,
        PlatformsSelector,
        ShortcutForm
    } from "@/components";
    import { uiId } from "@/utils/uiId";
    import ServerBundlesSelector from "@/components/Forms/ServerBundlesSelector";
    import NodesModeSelector from "@/components/Forms/NodesModeSelector";
    import CountrySelectorWithContinents from "@/components/Forms/Fields/CountrySelectorWithContinents";
    import DateRangeForm from "@/components/Forms/shorcut/DateRangeForm";

    export default {
        components: {
            ServerBundlesSelector,
            AppsSelector,
            ActionsForm,
            BenefitsForm,
            CountrySelectorWithContinents,
            CTAForm,
            ImagesForm,
            PrismEditor,
            PlatformsSelector,
            NodesModeSelector,
            ShortcutForm,
            DateRangeForm
        },
        data() {
            return {
                errorMsg: null,
                submitted: false,

                // tags
                tagsIndex: [],
                tagsList: [],
                selectTagValue: "",
                tags: [],

                componentKey: 0,
                showDialog: false,
                shortcut: {
                    title: "",
                    subtitle: "",
                    cta: {
                        disconnected: { "en": "Activate" },
                        connecting: { "en": "Activating..." },
                        connected: { "en": "Deactivate"}
                    },
                    images: {
                        iconImgUrl: "https://static.provpn.world/assguard/icons/untracable@3x.png",
                        bgImgUrl: "https://static.provpn.world/assguard/backgrounds/netflixBackground.png"
                    },
                    background_color: "",
                    actions: [
                        {
                            title: { "en": "" },
                            subtitle: { "en": "" },
                            imageUrl: "",
                            platform: "all",
                            url: {
                                app: "",
                                website: "",
                                store: ""
                            },
                            uiId: uiId()
                        },
                        {
                            title: { "en": "" },
                            subtitle: { "en": "" },
                            imageUrl: "",
                            platform: "iOS",
                            url: {
                                app: "",
                                website: "",
                                store: ""
                            },
                            uiId: uiId()
                        },
                        {
                            title: { "en": "" },
                            subtitle: { "en": "" },
                            imageUrl: "",
                            platform: "android",
                            url: {
                                app: "",
                                website: "",
                                store: ""
                            },
                            uiId: uiId()
                        },
                        {
                            title: { "en": "" },
                            subtitle: { "en": "" },
                            imageUrl: "",
                            platform: "windows",
                            url: {
                                app: "",
                                website: "",
                                store: ""
                            },
                            uiId: uiId()
                        }
                    ],
                    benefits: [
                        {
                          title: { "en": "" },
                          imageUrl: "",
                          platform: "all",
                          uiId: uiId()
                        },
                        {
                          title: { "en": "" },
                          imageUrl : "",
                          platform: "iOS",
                          uiId: uiId()
                        },
                        {
                          title: { "en": "" },
                          imageUrl: "",
                          platform: "android",
                          uiId: uiId()
                        },
                        {
                          title: { "en": "" },
                          imageUrl: "",
                          platform: "windows",
                          uiId: uiId()
                        }
                    ],
                    successful_message: "",
                    payload: "{}",
                    premium: false,
                    enabled: false,
                    index: 0,
                    requires_age_confirmation: false,
                    slug: "",
                    apps_access_type: "common",
                    apps: [],
                    countryAccessType: "common",
                    selectedCountries: [],
                    selectedPlatforms: [],
                    platformAccessType: "common",
                    short_title: "",
                    layout_style: "small",
                    keywords: "",
                    server_bundles: [],
                    nodes_list_expanded: false,
                    node_representation: "default_representation",
                    date_interval: {
                        enable_on_date_interval: false,
                        start_date: new Date().toISOString(),
                        end_date: new Date().toISOString()
                    },
                    sensitive: false,
                },
            };
        },
        validations: {
            shortcut: {
                title: {required},
                payload: {required, isValidJSON},
                type: {required},
                slug: {required},
                date_interval: {
                    start_date: {
                        isBeforeEndDate(value) {
                            if (!this.shortcut.date_interval.enable_on_date_interval) {
                                return true;
                            }
                            const start = new Date(value).getTime();
                            const end = new Date(this.shortcut.date_interval.end_date).getTime();
                            return start < end;
                        }
                    },
                    end_date: {
                        ifAfterStartDate(value) {
                            if (!this.shortcut.date_interval.enable_on_date_interval) {
                                return true;
                            }
                            const start = new Date(this.shortcut.date_interval.start_date).getTime();
                            const end = new Date(value).getTime();
                            return start < end;
                        }
                    },
                },
            },
        },
        mounted() {
            this.getTags();
        },
        methods: {
            modeChanged(e) {
                this.shortcut.countryAccessType = e;
            },
            countrySelected(e) {
                this.shortcut.selectedCountries = e;
            },
            platformSelected(e) {
                this.shortcut.selectedPlatforms = e;
            },
            platformModeChanged(e) {
                this.shortcut.platformAccessType = e;
            },
            onAppsListChanged(newList) {
                this.shortcut.apps = newList;
            },
            onAppsModeChanged(mode) {
                this.shortcut["apps_access_type"] = mode;
            },
            onServerListChanged(serverList) {
                this.shortcut.server_bundles = serverList;
            },
            onNodesListExtendedUpdate(newValue) {
                this.shortcut.nodes_list_expanded = newValue;
            },
            onNodesRepresentationUpdate(newValue) {
                this.shortcut.node_representation = newValue;
            },
            onDateRangeUpdate(newValue) {
                this.shortcut.date_interval = newValue;
            },
            getTags() {
                this.$http.get("/v1/tags").then(
                    res => {
                        let tagNames = [];

                        res.data.tags.forEach(el => tagNames.push(el.name));

                        this.tagsList = res.data.tags;
                        this.tagsIndex = tagNames;
                    },
                    err => {
                        console.error(err);
                    },);
            },
            addTag() {
                this.tags.push(this.selectTagValue);

                this.selectTagValue = "";
            },
            createTag(tag) {
                let body = {
                    tag: {
                        name: tag,
                        weight: parseInt(this.tagForm.weight, 10)
                    }
                };

                this.$http.post("/v1/tag/create", body).then(
                    res => {
                        this.getTags();
                    },
                    err => {
                        console.error(err);
                    }
                );
            },
            deleteChip(item) {
                this.tags = this.tags.filter(el => {
                    return el !== item;
                });
            },
            // TODO: remove workarounds
            createShortcut() {
                this.submitted = true;
                this.errorMsg = null;

                // stop here if form is invalid
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }

                let reqTags = [];

                this.tagsList.forEach(tag => {
                    this.tags.forEach(selectedTag => {
                        if (selectedTag === tag.name) {
                            reqTags.push(tag);
                        }
                    });
                });

                let body = {
                    title: {
                        "en": this.shortcut.title,
                    },
                    subtitle: {
                        "en": this.shortcut.subtitle,
                    },
                    successful_message: {
                        "en": this.shortcut.successful_message,
                    },
                    category: {
                        "en": this.shortcut.category,
                    },
                    background_color: this.shortcut.background_color,
                    images: this.shortcut.images,
                    actions: this.shortcut.actions,
                    benefits: this.shortcut.benefits,
                    tags: reqTags,
                    server_bundles: this.shortcut.server_bundles,
                    payload: JSON.parse(this.shortcut.payload.replace(/(\r\n|\n|\r)/gm, "")),
                    premium: this.shortcut.premium,
                    enabled: this.shortcut.enabled,
                    type: this.shortcut.type,
                    index: parseInt(this.shortcut.index, 10),
                    requires_age_confirmation: this.shortcut.requires_age_confirmation,
                    slug: this.shortcut.slug,
                    countries_iso_codes: this.shortcut.selectedCountries,
                    countries_access_type: this.shortcut.countryAccessType,
                    platform_access_type: this.shortcut.platformAccessType,
                    platforms: this.shortcut.selectedPlatforms,
                    apps: this.shortcut.apps,
                    "apps_access_type": this.shortcut["apps_access_type"],
                    comment: this.shortcut.comment,
                    cta: this.shortcut.cta,

                    short_title: {
                        "en": this.shortcut.short_title,
                    },
                    layout_style: this.shortcut.layout_style,
                    keywords: this.shortcut.keywords,

                    nodes_list_expanded: this.shortcut.nodes_list_expanded,
                    node_representation: this.shortcut.node_representation,

                    date_interval: this.shortcut.date_interval,
                    sensitive: this.shortcut.sensitive,
                };

                this.$http.post("/v1/shortcut/create", body).then(
                    res => {
                        this.$notify({
                            group: "foo",
                            title: "Shortcut created",
                        });

                        this.$router.push("/shortcuts");
                    },
                    err => {
                        this.$notify({
                            group: "foo",
                            title: "Error creating shortcut",
                        });
                        this.errorMsg = err;
                    },
                );
            },
        }
    };

    function isValidJSON(str) {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }

        return true;
    }
</script>


<style lang="scss" scoped>
    .shake-on-error .md-duplicated {
        animation-name: shake;
        animation-duration: 0.5s;
    }

    @keyframes shake {
        0% {
            transform: translate(15px);
        }
        20% {
            transform: translate(-15px);
        }
        40% {
            transform: translate(7px);
        }
        60% {
            transform: translate(-7px);
        }
        80% {
            transform: translate(3px);
        }
        100% {
            transform: translate(0px);
        }
    }

    .pulse-on-error >>> .md-duplicated {
        animation-name: pulse;
        animation-duration: 0.5s;
        animation-iteration-count: infinite;
        animation-direction: alternate;
        animation-timing-function: ease-in-out
    }

    @keyframes pulse {
        0% {
            transform: scale(1.1, 1.1);
        }
        100% {
            transform: scale(0.9, 0.9);
        }
    }

    .md-layout {
        padding: 0 50px;
    }

    .shortcut-form {
        max-width: 1000px;
    }

    .new-sh-columns-wrapper {
        display: flex;
        flex-direction: row;

        div ~ div {
            margin-left: 15px;
        }
    }
    @media only screen and (max-width: 500px) {
      .new-sh-columns-wrapper {
        flex-direction: column;

        div ~ div {
          margin-left: 0;
        }
      }
    }

    @media only screen
    and (max-width: 850px) {
        .mobile-container {
            padding: 0 !important;
        }
        .new-sh-columns-wrapper {
            flex-direction: column;
        }
    }
    @-webkit-media only screen and (max-width: 850px) {
        .mobile-container {
            padding: 0 !important;
        }
        .new-sh-columns-wrapper {
            flex-direction: column;
        }
    }
</style>
